import type { ReactElement } from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import type { RootState } from 'reducers/types';
import { getTheme } from 'selectors';

type RenderProps = {
  brandColor?: string;
  chat: boolean;
  footer: boolean;
  preFooter: boolean;
};

type ThemeProps = ConnectedProps<typeof connector> & {
  render: (args: RenderProps) => ReactElement<RenderProps>;
};

const ThemeComponent = ({
  render,
  brandColor,
  chat = true,
  footer = true,
  preFooter = true,
}: ThemeProps) => {
  const state = { brandColor, chat, footer, preFooter };
  return render(state);
};

const mapStateToProps = (state: RootState) => {
  const { chat, footer, preFooter, brandColor } = getTheme(state);
  return { chat, footer, preFooter, brandColor };
};

const connector = connect(mapStateToProps);
const Theme = connector(ThemeComponent);

export { Theme };
